module.exports = __webpack_public_path__ + "static/img22-73eb54325ffb86e991f5f8a06c70b23d.jpg";